<template>
  <div class="feedback-tab p-4">
    <template v-if="course.enable_rating">
      <div class="mb-3 text-center">
        <StarRating :rating="course.rating || 0" />
        <div class="text-center text-uppercase font-weight-bold text-primary">
          {{ course.rating || 0 }} out of 5 ({{
            course.surveys_submitted || 0
          }}
          reviews)
        </div>
      </div>
    </template>
    <template v-else>
      <div class="alert alert-info mb-3 text-center" style="font-size: 12px">
        There are not enough reviews to provide a rating for this course.
      </div>
    </template>
    <div v-if="course.show_survey" class="mb-3 text-center">
      <a class="btn btn-primary" :href="course.survey_url" target="_blank">Take the Survey</a>
    </div>
    <template v-if="!!course.testimonials">
      <hr />
      <h4 class="mb-3">Testimonials</h4>
      <div v-html="course.testimonials"></div>
    </template>
    <template v-if="!!course.trainer_comments">
      <hr />
      <h4 class="mb-3">Trainer Comments</h4>
      <div v-html="course.trainer_comments"></div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    course: { type: Object, required: true },
  },
};
</script>